import { ENTITY_LISTING_VIEW_TYPE } from '../../constants/common'

export const LISTING_CREATE_ACTION_NAME = 'createListing'

export const QA_NAME_LISTING_RESYNC_DISCLOSURE = 'listingResyncDisclosure'

export const QA_NAME_LISTINGS_CLEAR_FILTERS = 'listingsClearFilters'

export const QA_NAME_LISTINGS_PREVIEW = 'listingsPreview'

export const QA_NAME_LISTINGS_REFRESH_ERROR = 'listingsRefreshError'

export const QA_NAME_LISTINGS_RETRY = 'listingsRetry'

export const QA_NAME_LISTINGS_TABLE = 'rentalPortalListings'

export const QA_NAME_LISTINGS_TABLE_ADD_NEW = 'addNewListing'

export const LISTING_TABLE_SKELETON_ROWS = 10

// TODO: drop this list once the backend sends the flag in `available_filters`.
export const LISTINGS_INITIAL_RANGE_FILTER_NAMES = ['available_from', 'created']

export const LISTINGS_FILTER_PARAM = {
  addressPublic: 'address_public',
  availableFromGte: 'available_from_gte',
  availableFromLte: 'available_from_lte',
  building: 'building',
  closedGte: 'closed_at_gte',
  closedLte: 'closed_at_lte',
  createdBy: 'created_by',
  createdGte: 'created_gte',
  createdLte: 'created_lte',
  currency: 'currency',
  description: 'description',
  firstPublishedAtGte: 'first_published_at_gte',
  firstPublishedAtLte: 'first_published_at_lte',
  flat: 'flat',
  id: 'id',
  manager: 'responsible_manager',
  needsMyAction: 'needs_my_action',
  photos: 'photos',
  portal: 'portal',
  rentPriceGte: 'rent_price_gte',
  rentPriceLte: 'rent_price_lte',
  scheduledDeactivateGte: 'scheduled_deactivate_gte',
  scheduledDeactivateLte: 'scheduled_deactivate_lte',
  scheduledGoLiveGte: 'scheduled_go_live_gte',
  scheduledGoLiveLte: 'scheduled_go_live_lte',
  status: 'status',
  updatedGte: 'updated_gte',
  updatedLte: 'updated_lte',
}

export const LISTINGS_SINGLE_FIELD_API =
  'idwell-api/api/v3/rental-portal/listings/single-field/'

export const LISTINGS_MULTISELECT_FILTER_PARAMS = [
  LISTINGS_FILTER_PARAM.building,
  LISTINGS_FILTER_PARAM.currency,
  LISTINGS_FILTER_PARAM.description,
  LISTINGS_FILTER_PARAM.flat,
  LISTINGS_FILTER_PARAM.id,
  LISTINGS_FILTER_PARAM.manager,
  LISTINGS_FILTER_PARAM.photos,
  LISTINGS_FILTER_PARAM.status,
]

export const LISTING_ACTION_ACTIVATE = 'activate'

export const LISTING_ACTION_ARCHIVE = 'archive'

export const LISTING_ACTION_DEACTIVATE = 'deactivate'

export const LISTING_ACTION_EDIT = 'edit'

export const LISTING_ACTION_RESTORE = 'restore'

export const LISTING_ACTION_ARCHIVE_MASS = 'archiveMass'

export const LISTING_ACTION_RESTORE_MASS = 'restoreMass'

export const LISTING_SINGLE_ACTION_BY_MASS_ACTION = {
  [LISTING_ACTION_ARCHIVE_MASS]: LISTING_ACTION_ARCHIVE,
  [LISTING_ACTION_RESTORE_MASS]: LISTING_ACTION_RESTORE,
}

export const LISTING_ACTION_PERMISSION_NAME = {
  [LISTING_ACTION_ACTIVATE]: 'can_publish',
  [LISTING_ACTION_ARCHIVE]: 'can_archive',
  [LISTING_ACTION_DEACTIVATE]: 'can_publish',
  [LISTING_ACTION_EDIT]: 'can_edit',
}

export const LISTING_UNAVAILABLE_ACTIONS = [LISTING_ACTION_ACTIVATE]

export const LISTING_ACTION_NOT_ALLOWED_TOOLTIP_KEY = {
  [LISTING_ACTION_ACTIVATE]:
    'RentalPortal.ListingStatusChangeNotAllowedTooltipKey',
  [LISTING_ACTION_ARCHIVE]: 'RentalPortal.ListingArchiveNotAllowedTooltipKey',
  [LISTING_ACTION_DEACTIVATE]:
    'RentalPortal.ListingStatusChangeNotAllowedTooltipKey',
  [LISTING_ACTION_EDIT]: 'RentalPortal.ListingEditNotAllowedTooltipKey',
}

export const LISTING_MASS_ACTION = {
  archive: 'archive',
  restore: 'restore',
}

export const LISTING_MASS_ACTION_NAMES = {
  [LISTING_ACTION_ARCHIVE]: LISTING_MASS_ACTION.archive,
  [LISTING_ACTION_ARCHIVE_MASS]: LISTING_MASS_ACTION.archive,
  [LISTING_ACTION_RESTORE]: LISTING_MASS_ACTION.restore,
  [LISTING_ACTION_RESTORE_MASS]: LISTING_MASS_ACTION.restore,
}

export const LISTING_READINESS_LABEL_KEY = {
  description: 'RentalPortal.ListingReadinessDescriptionKey',
  photo: 'RentalPortal.ListingReadinessPhotoKey',
  rent: 'RentalPortal.ListingReadinessRentKey',
}

export const LISTING_PORTAL_SYNC_STATUS = {
  deactivated: 'deactivated',
  deactivating: 'deactivating',
  error: 'error',
  notPublished: 'not_published',
  published: 'published',
  publishing: 'publishing',
  queued: 'queued',
  updatePending: 'update_pending',
  updating: 'updating',
}

const LISTING_STATUS_BADGE = {
  deactivated: 'deactivated',
  draft: 'draft',
  let: 'let',
  notOnAnyPortal: 'not_on_any_portal',
  notOnAnyPortalError: 'not_on_any_portal_error',
  publicationFailed: 'publication_failed',
  published: 'published',
  publishedWithErrors: 'published_with_errors',
  submitted: 'submitted',
}

export const LISTING_STATUS_BADGES = {
  [LISTING_STATUS_BADGE.deactivated]: {
    text: 'RentalPortal.ListingStatusDeactivatedKey',
    textColor: 'var(--color-warning)',
  },
  [LISTING_STATUS_BADGE.draft]: {
    text: 'RentalPortal.ListingStatusDraftKey',
    textColor: 'var(--secondary-text-color)',
  },
  [LISTING_STATUS_BADGE.let]: {
    text: 'RentalPortal.ListingStatusClosedKey',
    textColor: 'var(--color-info)',
  },
  [LISTING_STATUS_BADGE.notOnAnyPortal]: {
    text: 'RentalPortal.ListingBadgeNotOnAnyPortalKey',
    textColor: 'var(--secondary-text-color)',
  },
  [LISTING_STATUS_BADGE.notOnAnyPortalError]: {
    isWarning: true,
    text: 'RentalPortal.ListingBadgeNotOnAnyPortalKey',
    textColor: 'var(--color-warning)',
  },
  [LISTING_STATUS_BADGE.publicationFailed]: {
    text: 'RentalPortal.ListingBadgePublicationFailedKey',
    textColor: 'var(--color-error)',
  },
  [LISTING_STATUS_BADGE.published]: {
    text: 'RentalPortal.ListingStatusPublishedKey',
    textColor: 'var(--color-success)',
  },
  [LISTING_STATUS_BADGE.publishedWithErrors]: {
    isWarning: true,
    text: 'RentalPortal.ListingBadgePublishedWithErrorsKey',
    textColor: 'var(--color-warning)',
  },
  [LISTING_STATUS_BADGE.submitted]: {
    text: 'RentalPortal.ListingProfilePortalPublishingKey',
    textColor: 'var(--color-info)',
  },
}

export const LISTING_ALREADY_PUBLISHED_TEXT_COLOR = 'var(--color-warning)'

export const LISTING_STATUS_BADGE_WARNING_ICON_COLOR = 'var(--color-warning)'

export const LISTING_PUBLICATION_IN_PROGRESS_ERROR_KEY =
  'ServerError.RentalListingPublicationInProgressKey'

export const LISTING_PUBLICATION_IN_PROGRESS_ERROR_CODE =
  'Publication_for_this_flat_already_in_progress'

export const LISTING_FLAT_ALREADY_PUBLISHED_ERROR_CODE =
  'Flat_already_has_a_published_listing'

export const LISTING_UNIT_LOCKED_ERROR_CODE = 'Listing_unit_is_locked'

export const LISTING_FLAT_NOT_FOUND_ERROR_CODE = 'Flat_not_found'

export const LISTING_CHANGED_BY_SOMEONE_ELSE_ERROR_CODE =
  'Listing_was_changed_by_someone_else'

export const LISTING_EDIT_CONFLICT_NOTIFICATION_ID = 'listingEditConflict'

export const LISTING_PORTAL = {
  immoscout24: 'immoscout24',
  immowelt: 'immowelt',
}

export const LISTING_PORTAL_LABEL = {
  [LISTING_PORTAL.immoscout24]: 'ImmoScout24',
  [LISTING_PORTAL.immowelt]: 'Immowelt',
}

// TODO: replace the mock-media monograms with the real portal marks in src/icons once design hands them over
export const LISTING_PORTAL_LOGO_PATH = {
  [LISTING_PORTAL.immoscout24]: 'media/portals/immoscout24.svg',
  [LISTING_PORTAL.immowelt]: 'media/portals/immowelt.svg',
}

export const LISTING_ARCHIVE_PORTAL_NAMES_LIMIT = 3

export const LISTING_COLUMN_NAME = {
  AddressPublic: 'address_public',
  Applicants: 'applicant_count',
  Applications: 'applications',
  AvailableFrom: 'available_from',
  Building: 'building',
  ClosedAt: 'closed_at',
  Conversion: 'conversion_pct',
  Created: 'created',
  CreatedBy: 'created_by',
  DaysToLet: 'days_to_let',
  DepositAmount: 'deposit_amount',
  FirstPublishedAt: 'first_published_at',
  HeatingCosts: 'heating_costs',
  Inquiries: 'inquiries',
  OtherCosts: 'other_costs',
  Photos: 'photos',
  Portals: 'portal_status_summary',
  Rent: 'rent_price',
  ResponsibleManager: 'responsible_manager',
  ScheduledDeactivate: 'scheduled_deactivate',
  ScheduledGoLive: 'scheduled_go_live',
  ServiceCharge: 'service_charge',
  Status: 'status',
  Unit: 'flat',
  Updated: 'updated',
  ViewingCount: 'viewings',
  WaitingOn: 'waiting_on',
}

export const LISTING_DAYS_TO_LET_EMPTY_VALUE = '—'

export const LISTING_PAYLOAD_FIELD = {
  attention: 'attention',
  bucketing: 'status',
  reporting: 'conversion_pct',
}

export const LISTING_VIEW_TYPES = [
  ENTITY_LISTING_VIEW_TYPE.board,
  ENTITY_LISTING_VIEW_TYPE.boardWithPreview,
  ENTITY_LISTING_VIEW_TYPE.table,
  ENTITY_LISTING_VIEW_TYPE.tableWithPreview,
]

export const LISTING_WAITING_ON = {
  applicant: 'applicant',
  colleague: 'colleague',
  nobody: 'nobody',
  you: 'you',
}

export const LISTING_PUBLICATION_LIVE_SYNC_STATUSES = [
  LISTING_PORTAL_SYNC_STATUS.deactivating,
  LISTING_PORTAL_SYNC_STATUS.published,
  LISTING_PORTAL_SYNC_STATUS.updatePending,
  LISTING_PORTAL_SYNC_STATUS.updating,
]

export const LISTING_FORM_DEPOSIT_TEXT_MAX_LENGTH = 128

export const LISTING_FORM_FIELD_NAME_AVAILABLE_FROM = 'available_from'

export const LISTING_FORM_FIELD_NAME_BUILDING = 'building'

export const LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT = 'deposit_amount'

export const LISTING_FORM_FIELD_NAME_DEPOSIT_TEXT = 'deposit_text'

export const LISTING_FORM_FIELD_NAME_DESCRIPTION = 'description'

export const LISTING_FORM_FIELD_NAME_FLAT = 'flat'

export const LISTING_FORM_FIELD_NAME_PHOTOS = 'photos'

export const LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE =
  'scheduled_deactivate'

export const LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE = 'scheduled_go_live'

export const LISTING_FORM_FIELD_NAME_PORTALS = 'portals'

export const LISTING_FORM_FIELD_NAME_RENT_PRICE = 'rent_price'

export const LISTING_FORM_FIELD_NAME_SERVICE_CHARGE = 'service_charge'

export const LISTING_TRANSITION = {
  deactivate: 'deactivate',
}

export const LISTING_TRANSITION_REASON = {
  archived: 'archived',
  flatAlreadyPublished: 'flat_already_published',
  flatPublicationInProgress: 'flat_publication_in_progress',
  noPortalSelected: 'no_portal_selected',
  readinessIncomplete: 'readiness_incomplete',
  wrongStatus: 'wrong_status',
}

export const LISTING_AMOUNT_MAX = 99999999.99

export const LISTING_SERVER_ERROR_CODE_PATTERN = /^\w+$/

export const LISTING_SERVER_ERROR_AMOUNT_LIMIT_PATTERN = /_digits_/

export const LISTING_SERVER_ERROR_TEXT_KEY = {
  Amount_must_not_be_negative: 'Error.EnterPositiveNumberKey',
  Rent_price_must_be_positive: 'RentalPortal.ListingRentPositiveErrorKey',
}
